import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Link
      to="/contact"
      className={`fixed bottom-6 left-6 z-50 bg-charcoal text-white px-6 py-3.5 rounded-xl font-inter font-semibold text-[15px] shadow-lg hover:bg-primary hover:shadow-xl transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center gap-2 ${
        isVisible
          ? 'translate-y-0 opacity-100'
          : 'translate-y-4 opacity-0 pointer-events-none'
      }`}
    >
      <i className="ri-phone-line text-lg w-5 h-5 flex items-center justify-center"></i>
      Book a Strategy Call
    </Link>
  );
}
